var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon/phone"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"icon/phone","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","key":2},[React.createElement("rect",{"id":"Rectangle","stroke":"#4355F3","strokeWidth":"3","strokeLinejoin":"round","x":"1.5","y":"3","width":"25","height":"35","rx":"2","key":0}),React.createElement("path",{"d":"M2,30 L26.5,30","id":"Line-2","stroke":"#4355F3","strokeWidth":"3","key":1}),React.createElement("path",{"d":"M9,8 L18.765278,8","id":"Line-2-Copy","stroke":"#4355F3","strokeWidth":"3","key":2})])]);
}

Phone.defaultProps = {"width":"40px","height":"40px","viewBox":"0 0 40 40","version":"1.1"};

module.exports = Phone;

Phone.default = Phone;
